// src/pages/Projects.jsx
import React from 'react';

const projects = [
  {
    id: 1,
    title: "Enterprise IAM Platform",
    description: "Scalable authentication system for 300K+ enterprise users with 99.5%+ availability.",
    tech: ["Java/Spring", "Microservices", "SaaS", "Security"],
    category: "Cloud Architecture",
    achievements: [
      "99.5%+ availability for authentication system",
      "Scaled to support 300,000+ enterprise users",
      "Multi-tenant architecture (Cloud & On-premise)",
      "Real-time data exchange between services"
    ]
  },
  {
    id: 2,
    title: "Payroll SaaS Module",
    description: "Cloud-native payroll features built with microservices architecture.",
    tech: ["REST APIs", "TDD/BDD", "CI/CD", "Automation"],
    category: "Product Development",
    achievements: [
      "Automated key processes reducing manual workload",
      "Implemented TDD/BDD practices in CI/CD pipelines",
      "Cross-functional collaboration with PMs and UX",
      "Enhanced core software components"
    ]
  },
  {
    id: 3,
    title: "Vulnerability Management System",
    description: "ITIL-compliant system for automated vulnerability processing across multiple sources.",
    tech: ["Spring Boot", "ServiceNow", "ETL", "Automation"],
    category: "Data Systems",
    achievements: [
      "Automated end-to-end vulnerability lifecycle",
      "ServiceNow integration for ITSM incidents",
      "Processing from 3+ security data sources",
      "ITIL-compliant bulletin processing"
    ]
  }
];

const Projects = () => {
  return (
    <section className="full-section">
      <div className="section-header-full">
        <h1>Projects</h1>
        <p>Enterprise systems and solutions built at scale</p>
      </div>
      <div className="projects-grid-full">
        {projects.map(project => (
          <div key={project.id} className="project-card-full">
            <div className="project-header-full">
              <h2>{project.title}</h2>
              <span className="project-category-full">{project.category}</span>
            </div>
            <p className="project-description">{project.description}</p>
            <div className="project-tech-full">
              {project.tech.map(tech => (
                <span key={tech} className="tech-tag-full">{tech}</span>
              ))}
            </div>
            <div className="project-achievements">
              <h4>Key Achievements</h4>
              <ul>
                {project.achievements.map((achievement, index) => (
                  <li key={index}>{achievement}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;